// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UKNO","textarea":"styles_textarea__-lTmM"};